// extracted by mini-css-extract-plugin
export var legal_container = "legal-module--legal_container--UIqdp";
export var sectionHeader = "legal-module--sectionHeader--+cyEL";
export var sectionHeaderInner = "legal-module--sectionHeaderInner--K+MFw";
export var sectionHeaderLogo = "legal-module--sectionHeaderLogo--kJDYY";